import { render, staticRenderFns } from "./WorkflowImport.vue?vue&type=template&id=56ff9b47&"
import script from "./WorkflowImport.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowImport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports